import { useState, type FC } from "react";
import CheckmarkConfetti from "./CheckmarkConfetti";

const AnimationTest: FC = () => {
    const [showConfetti, setShowConfetti] = useState<boolean>(false);

    const handleButtonClick = (): void => {
        setShowConfetti(true);
    };

    return (
        <div className="tw-flex tw-justify-center tw-pt-4">
            <button onClick={handleButtonClick}>Checkmark Confetti</button>

            <CheckmarkConfetti play={showConfetti} setPlay={setShowConfetti} />
        </div>
    );
};

export default AnimationTest;
